<template>
	<div class="gerainside">
	<b-container class="container-lg mt-top text-left prl-outside">
		<p class="text-left">
			{{$t('titleText')}}
		</p>
		<b-row class="ml-0 grid" style="padding-top:20px;">
      <div class="col3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[16])">
        <img :src="require(`@/assets/img/GeraInside/${stories[16].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[16].userPicture}`)"/></div>
          <div class="text">{{stories[16].user}}<br>{{$t('on')}} {{stories[16].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[16].title}}</h3>
          <p class="fs09" v-html="stories[16].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[15])">
        <img :src="require(`@/assets/img/GeraInside/${stories[15].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[15].userPicture}`)"/></div>
          <div class="text">{{stories[15].user}}<br>{{$t('on')}} {{stories[15].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[15].title}}</h3>
          <p class="fs09" v-html="stories[15].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[14])">
        <img :src="require(`@/assets/img/GeraInside/${stories[14].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[14].userPicture}`)"/></div>
          <div class="text">{{stories[12].user}}<br>{{$t('on')}} {{stories[14].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[14].title}}</h3>
          <p class="fs09" v-html="stories[14].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[13])">
        <img :src="require(`@/assets/img/GeraInside/${stories[13].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[13].userPicture}`)"/></div>
          <div class="text">{{stories[12].user}}<br>{{$t('on')}} {{stories[13].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[13].title}}</h3>
          <p class="fs09" v-html="stories[13].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[12])">
        <img :src="require(`@/assets/img/GeraInside/${stories[12].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[12].userPicture}`)"/></div>
          <div class="text">{{stories[12].user}}<br>{{$t('on')}} {{stories[12].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[12].title}}</h3>
          <p class="fs09" v-html="stories[12].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-3 col-lg-3 pr30 mb30 cursorp" @click="showStory(stories[11])">
        <img :src="require(`@/assets/img/GeraInside/${stories[11].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[11].userPicture}`)"/></div>
          <div class="text">{{stories[11].user}}<br>{{$t('on')}} {{stories[11].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[11].title}}</h3>
          <p class="fs09" v-html="stories[11].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-6 col-lg-6 pr30 mb30 cursorp" @click="showStory(stories[10])">
        <img :src="require(`@/assets/img/GeraInside/${stories[10].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[10].userPicture}`)"/></div>
          <div class="text">{{stories[10].user}}<br>{{$t('on')}} {{stories[10].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[10].title}}</h3>
          <p class="fs09" v-html="stories[10].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-6 col-lg-6 pr30 mb30 cursorp" @click="showStory(stories[9])">
        <img :src="require(`@/assets/img/GeraInside/${stories[9].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[9].userPicture}`)"/></div>
          <div class="text">{{stories[9].user}}<br>{{$t('on')}} {{stories[9].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[9].title}}</h3>
          <p class="fs09" v-html="stories[9].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-6 col-lg-6 pr30 mb30 cursorp" @click="showStory(stories[8])">
        <img :src="require(`@/assets/img/GeraInside/${stories[8].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[8].userPicture}`)"/></div>
          <div class="text">{{stories[8].user}}<br>{{$t('on')}} {{stories[8].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[8].title}}</h3>
          <p class="fs09" v-html="stories[8].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-4 col-lg-4 pr30 mb30 cursorp" @click="showStory(stories[7])">
        <img :src="require(`@/assets/img/GeraInside/${stories[7].picture}`)" style="object-position: 0 20%"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[7].userPicture}`)"/></div>
          <div class="text">{{stories[7].user}}<br>{{$t('on')}} {{stories[7].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[7].title}}</h3>
          <p class="fs09" v-html="stories[7].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-8 col-lg-8 pr30 mb30 cursorp" @click="showStory(stories[6])">
        <img :src="require(`@/assets/img/GeraInside/${stories[6].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[6].userPicture}`)"/></div>
          <div class="text">{{stories[6].user}}<br>{{$t('on')}} {{stories[6].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[6].title}}</h3>
          <p class="fs09" v-html="stories[6].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
		  <div class="col-4 col-lg-4 pr30 mb30 cursorp" @click="showStory(stories[5])">
        <img :src="require(`@/assets/img/GeraInside/${stories[5].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[5].userPicture}`)"/></div>
          <div class="text">{{stories[5].user}}<br>{{$t('on')}} {{stories[5].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[5].title}}</h3>
          <p class="fs09" v-html="stories[5].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-8 col-lg-8 pr30 mb30 cursorp" @click="showStory(stories[0])">
        <img :src="require(`@/assets/img/GeraInside/${stories[0].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[0].userPicture}`)"/></div>
          <div class="text">{{stories[0].user}}<br>{{$t('on')}} {{stories[0].date}}</div>
        </div>
        <div class="hotspot one-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[0].title}}</h3>
          <p class="fs09" v-html="stories[0].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-md-12 col-lg-8 pr30 mb30 cursorp" @click="showStory(stories[3])">
        <img :src="require(`@/assets/img/GeraInside/${stories[3].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[3].userPicture}`)"/></div>
          <div class="text">{{stories[3].user}}<br>{{$t('on')}} {{stories[3].date}}</div>
        </div>
        <div class="hotspot one-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[3].title}}</h3>
          <p class="fs09" v-html="stories[3].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-6 col-lg-4 pr30 mb30 cursorp" @click="showStory(stories[1])">
        <img :src="require(`@/assets/img/GeraInside/${stories[1].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[1].userPicture}`)"/></div>
          <div class="text">{{stories[1].user}}<br>{{$t('on')}} {{stories[1].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[1].title}}</h3>
          <p class="fs09" v-html="stories[1].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-6 col-lg-4 pr30 mb30 cursorp" @click="showStory(stories[2])">
        <img :src="require(`@/assets/img/GeraInside/${stories[2].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[2].userPicture}`)"/></div>
          <div class="text">{{stories[2].user}}<br>{{$t('on')}} {{stories[2].date}}</div>
        </div>
        <div class="hotspot two-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[2].title}}</h3>
          <p class="fs09" v-html="stories[2].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>
      <div class="col-12 col-lg-8 pr30 mb30 cursorp" @click="showStory(stories[4])">
        <img :src="require(`@/assets/img/GeraInside/${stories[4].picture}`)"/>
        <div class="info-line">
          <div class="pic"><img :src="require(`@/assets/img/team/${stories[4].userPicture}`)"/></div>
          <div class="text">{{stories[4].user}}<br>{{$t('on')}} {{stories[4].date}}</div>
        </div>
        <div class="hotspot one-third wcm15" style="overflow:auto;">
          <h3 class="mt-2">{{stories[4].title}}</h3>
          <p class="fs09" v-html="stories[4].titleText"></p>
        </div>
        <div class="link-to-story">{{$t('more')}}</div>
      </div>


		</b-row>
	</b-container>

	<div class="big-text">{{$t('title')}}</div>
	</div>
</template>
<script>
export default {
  name: 'GeraInside',
  data () {
    return {
    	overlayVisible: false,
    	selectedStory: null,
    	stories: [
			{
				picture: 'Damp1_717x350.jpg',
				user: 'Rudi Grabner',
				userPicture: 'Grabner Rudolf.jpg',
    			date: this.$t('story5Date'),
    			title: this.$t('story5Title'),
    			titleText: this.$t('story5TitleText'),
				articleText: this.$t('story5ArticleText'),
				pictures: [ 'Damp1.jpg', 'Damp 2.jpg', 'Damp 3.jpg', 'Damp 4.jpg', 'Damp 5.jpg', 'Damp 6.jpg', 'Damp 7.jpg' ]
			},
			{
				picture: 'Kart_1_350x350.jpg',
				user: 'Helmut Raggam',
				userPicture: 'Raggam Helmut.jpg',
    			date: this.$t('story4Date'),
    			title: this.$t('story4Title'),
    			titleText: this.$t('story4TitleText'),
				articleText: this.$t('story4ArticleText'),
				pictures: [ 'Kart 1.jpeg', 'Kart 2.jpeg', 'Kart 3.jpeg' ]
			},
			{
				picture: 'Parlament_Wien_350x350.jpg',
				user: 'Rudi Grabner',
				userPicture: 'Grabner Rudolf.jpg',
    			date: this.$t('story3Date'),
    			title: this.$t('story3Title'),
    			titleText: this.$t('story3TitleText'),
				articleText: this.$t('story3ArticleText'),
				pictures: [ 'Parlament Wien.jpeg' ]
			},
			{
				picture: 'Hilton_Wien_717x350.jpg',
				user: 'Herbert Raggam',
				userPicture: 'Raggam Herbert.jpg',
    			date: this.$t('story2Date'),
    			title: this.$t('story2Title'),
    			titleText: this.$t('story2TitleText'),
				articleText: this.$t('story2ArticleText'),
				pictures: [ 'Hilton Wien am Stadtpark 1.jpeg' ]
			},
			{
    			picture: 'GERA_Inside_Pic1.jpg',
    			user: 'Rudi Grabner',
    			userPicture: 'Grabner Rudolf.jpg',
    			date: this.$t('story1Date'),
    			title: this.$t('story1Title'),
    			titleText: this.$t('story1TitleText'),
				articleText: this.$t('story1ArticleText'),
				pictures: [ 'WhatsApp Image 2020-04-15 at 18.48.35 (1).jpeg', 'WhatsApp Image 2020-04-15 at 18.47.44 (1).jpeg', 'WhatsApp Image 2020-04-15 at 18.47.44 (2).jpeg', 'WhatsApp Image 2020-04-15 at 18.47.44 (3).jpeg', 'WhatsApp Image 2020-04-15 at 18.47.44 (4).jpeg', 'WhatsApp Image 2020-04-15 at 18.47.44.jpeg', 'WhatsApp Image 2020-04-15 at 18.48.35.jpeg' ]
    	},
			{
    			picture: 'Gera_Urkunde_340729328_.jpg',
    			user: 'Herbert Raggam',
    			userPicture: 'Raggam Herbert.jpg',
    			date: this.$t('story6Date'),
    			title: this.$t('story6Title'),
    			titleText: this.$t('story6TitleText'),
				articleText: this.$t('story6ArticleText'),
				pictures: [ 'Thanks.jpeg', 'Gera_Urkunde_340729328.jpg', 'PIN_13_68_Firmentreuemichijpg.jpg' ]
    	},
			{
    			picture: 'Poly 2.jpg',
    			user: 'Herbert Raggam',
    			userPicture: 'Raggam Herbert.jpg',
    			date: this.$t('story7Date'),
    			title: this.$t('story7Title'),
    			titleText: this.$t('story7TitleText'),
				articleText: this.$t('story7ArticleText'),
				pictures: [ 'Poly 2.jpg', 'Poly 3.jpg' ]
    		},
        {
          picture: 'story8-Binder.jpg',
          user: 'Herbert Raggam',
          userPicture: 'Raggam Herbert.jpg',
          date: this.$t('story8Date'),
          title: this.$t('story8Title'),
          titleText: this.$t('story8TitleText'),
          articleText: this.$t('story8ArticleText'),
          pictures: [ 'story8-Binder.jpg', 'story8-Bluehwald.jpg', 'story8-Legenstein.jpg', 'story8-Rojc.jpg', 'story8-Lechner.jpg', 'story8-Sudi.jpg' ]
        },
        {
          picture: 'story9-GERA-on-tour-1.jpg',
          user: 'Herbert Raggam',
          userPicture: 'Raggam Herbert.jpg',
          date: this.$t('story9Date'),
          title: this.$t('story9Title'),
          titleText: this.$t('story9TitleText'),
          articleText: this.$t('story9ArticleText'),
          pictures: [ 1, 2, 3, 4, 5 ].map(i => `story9-GERA-on-tour-${i}.jpg`)
        },
        {
          picture: 'story10-graz-5.jpg',
          user: 'Herbert Raggam',
          userPicture: 'Raggam Herbert.jpg',
          date: this.$t('story10Date'),
          title: this.$t('story10Title'),
          titleText: this.$t('story10TitleText'),
          articleText: this.$t('story10ArticleText'),
          pictures: [ 1, 5 ].map(i => `story10-graz-${i}.jpg`)
        },
        {
          picture: 'story11-eisenstadt-1.jpg',
          user: 'Herbert Raggam',
          userPicture: 'Raggam Herbert.jpg',
          date: this.$t('story11Date'),
          title: this.$t('story11Title'),
          titleText: this.$t('story11TitleText'),
          articleText: this.$t('story11ArticleText'),
          pictures: [ 1, 2, 3, 4, 5 ].map(i => `story11-eisenstadt-${i}.jpg`)
        },
        {
            picture: '75gH6i.jpg',
            user: 'Rudi Grabner',
            userPicture: 'Grabner Rudolf.jpg',
            date: this.$t('story12Date'),
            title: this.$t('story12Title'),
            titleText: this.$t('story12TitleText'),
            articleText: this.$t('story12ArticleText'),
            pictures: ['75gH6i.jpg'],
        },
        {
            picture: 'thumbnail_IMG_8716.jpg',
            user: 'Rudi Grabner',
            userPicture: 'Grabner Rudolf.jpg',
            date: this.$t('story13Date'),
            title: this.$t('story13Title'),
            titleText: this.$t('story13TitleText'),
            articleText: this.$t('story13ArticleText'),
            pictures: ['thumbnail_IMG_8716.jpg'],
        },
        {
            picture: '6 Helmut (2).jpg',
            user: 'Rudolfi Grabner',
            userPicture: 'Grabner Rudolf.jpg',
            date: this.$t('story14Date'),
            title: this.$t('story14Title'),
            titleText: this.$t('story14TitleText'),
            articleText: this.$t('story14ArticleText'),
            pictures: ['1 Bläser.jpg', '2 Feuer im Hof.jpg', '3 Blick in den Sall leer.jpg', '4 Blick in den Saal bei Ansprache.jpg', '6 Helmut (1).jpg', '7 Rudi Ansprache.jpg', '8 Buffet 2.jpg'],
        },
        {
            picture: 'story-22.jpg',
            user: 'Rudolf Grabner',
            userPicture: 'Grabner Rudolf.jpg',
            date: this.$t('story22Date'),
            title: this.$t('story22Title'),
            titleText: this.$t('story22TitleText'),
            articleText: this.$t('story22ArticleText'),
            pictures: ['story-22.jpg'],
        },
        {
            picture: '22_Gruppenbild.jpg',
            user: 'Helmut Raggam',
            userPicture: 'Raggam Helmut.jpg',
            date: this.$t('story23Date'),
            title: this.$t('story23Title'),
            titleText: this.$t('story23TitleText'),
            articleText: this.$t('story23ArticleText'),
            pictures: [
              { image: '22_Gruppenbild.jpg', caption: 'Das gesamte Jubilar-Team mit GF Helmut Raggam' },
              { image: '22_Puches.jpg', caption: 'Markus Puches 15 Jahre' },
              { image: '22_Schreiber.jpg', caption: 'Josef Schreiber feiert 25 Jahre' },
              { image: '22_Kirbisser.jpg', caption: '30 Jahre Treue: Franz Kirbisser' },
              { image: '22_Poschauko.jpg', caption: 'Michael Poschauko 30 Jahre' },
            ],
        },
        {
            picture: 'POLY_12.2.26.jpg',
            user: 'Herbert Raggam',
            userPicture: 'Raggam Herbert.jpg',
            date: this.$t('story24Date'),
            title: this.$t('story24Title'),
            titleText: this.$t('story24TitleText'),
            articleText: this.$t('story24ArticleText'),
            pictures: [
              { image: 'POLY_12.2.26.jpg', caption: 'Die Sieger des Wettbewerbs mit Herbert Raggam' }
            ],
        }
/*
    			date: this.$t('story1'),
			"story2Date": "",
			"story2Title": "",
			"story2TitleText": "",
			"story2ArticleText": "",
*/
    	]
    }

  },
  methods: {
  	showOverlay(story) {
  		this.selectedStory = story
  		this.overlayVisible = true
  	},
  	hideOverlay() {
  		this.overlayVisible = true
  		this.selectedStory = null
	  },
	showStory (story) {
		this.$store.state.story = story
		this.$router.push('/Gerainside/story')
	}
  },
  computed: {
  },
  created () {
	  this.$store.state.story = null
  }
}
</script>

<style>
.info-line {
	position:absolute;
	z-index:1;
	top:10px;
	left:10px;
	background-color: rgba(255,255,255,0.5);
	padding: 2px;
	padding-right: 5px;
	border-radius: 5px;
}
.info-line .pic {
	float:left;
	width:37px;
	border-radius:5px;
	overflow:hidden;
	border:solid 1px grey;
}
.info-line .text {
	float:left;
	font-size: 12px;
	font-weight:700;
	color: black;
	margin-left: 15px;
}
</style>
<style scoped>
.grid > * {
  height: 350px;
  position: relative;
  overflow: hidden;
}
.grid > * > img {
  object-fit: cover;
}
.gerainside .row img {
	width:100%;
	height:100%;
}
.hotspot {
	opacity: 0;
	width:100%;
	height:100%;
	top:0;
	left:0;
	position:absolute;
	background-color: rgba(0,0,0,0.5);
	color:white;
	padding:40px 20px 15px;
	margin-right:15px;
	text-align:left;
	z-index: 5;
	transition: opacity 0.5s ease-in-out;
}
.hotspot:hover {
	opacity: 1;
}
.one-third {
	width:96.3% !important;
}
.two-third {
	width:92.5% !important;
}
.pr30 {
	padding: 0 15px 0 0 !important;
}
.mb30 {
 	margin: 0 0 15px 0;
}
.wcm15 {
	width:calc(100% - 15px) !important;
}
.link-to-story {
	position:absolute;right:20px;bottom:0;color:white;font-weight:bold;font-size:0.7em;padding:3px;z-index:10;
}
@media only screen and (max-width: 1400px) {
	h3 { font-size:1.5em; }
	p { font-size: 0.8em; }
}
</style>
<i18n>
	{
		"de": {
			"title": "GERA Inside",
			"titleText": "Wir sind ein perfekt eingeschultes Team, das immer auf Hochtouren ist, um die ganze Welt kommt und perfekte Ergebnisse liefert – und genau deswegen gibt es viel zu berichten! Ist das Endergebnis gelungen freut sich nicht nur unser Kunde, sondern auch wir dürfen das eine oder andere Mal feiern! Sehen Sie selbst:",
			"more": "Mehr...",
			"on": "am",
			"story1Date": "20. April 2020",
			"story1Title": "Teambuilding am Wasser",
			"story1TitleText": "Damit sich unser Führungsteam (Management und Projektleiter) auch mal abseits der Arbeit auf die Ziele für die Zukunft einschwören kann, geht es fast jährlich an ausgefallene Orte bzw. in eine entspannte Umgebung. Der Boot Trip von 2017 ist dabei in besonderer Erinnerung geblieben.",
			"story1ArticleText": "",
			"story2Date": "14. Juni 2020",
			"story2Title": "Hausherrin Paris wäre wohl stolz auf uns",
			"story2TitleText": "Eine Top-Adresse ist das Hotel Hilton am Wiener Stadtpark: Seit kurzem ist die einjährige Bauphase mit mehr als 600 Zimmern und Suiten fertig gestellt. Trotz der schwierigen Bedingungen im heurigen Jahr haben wir das nahezu unmögliche geschafft und das Projekt termingerecht, übergeben!<br>Zeit unserem erstklassigen Team einfach nur DANKE zu sagen!",
			"story2ArticleText": "",
			"story3Date": "9. Juli 2020",
			"story3Title": "Parlament Wien",
			"story3TitleText": "Während unser Nationalrat sich gerade gemütlich auf die Sommerpause im Parlament einstellt machen wir das Gegenteil! Wir legen kräftig Hand an, um die altehrwürdigen Räume in neuen Glanz zu hüllen!",
			"story3ArticleText": "",
			"story4Date": "14. Juli 2020",
			"story4Title": "Wieder aktiv werden",
			"story4TitleText": "GERA aktiv ist fast schon legendär.... Gemeinsam Zeit verbringen, spannende, aufregende, lustige Dinge tun, Sport treiben, Spaß haben, wie zum Beispiel beim Kartfahren. Oft haben wir das schon gemeinsam genossen und bald es ist wieder an der Zeit, dass neue Highlights in unserer internen Eventserie statt finden.",
			"story4ArticleText": "",
			"story5Date": "29. Juli 2020",
			"story5Title": "Norddeutsche Vision trifft auf südsteirische Willenskraft",
			"story5TitleText": "Im malerischen Damp an der Ostsee haben wir in den ersten Monaten des heurigen Jahres besonders überzeugt: Mehr als 400 Zimmer und Suiten wurden von uns im extrem kurzen Montagezeitraum von nur 4 Monaten perfekt montiert: Unser Kunde ist so glücklich über unsere Top-Leistung, dass er uns ein eigenes Fotobuch als Dokumentation unserer eisernen Willenskraft und Konsequenz zusammen gestellt hat.<br>Ein herzliches Danke an unser großartiges Team für diesen tollen Einsatz!",
			"story5ArticleText": "",
			"story6Date": "9. März 2021",
			"story6Title": "Das wertvollste Gut eines Unternehmens sind die Mitarbeiter",
			"story6TitleText": "Das wissen auch wir, und umso mehr erfüllt es uns mit Freude und Stolz, dass wir unlängst vier langjährig treuen Teammitgliedern Danke sagen zu durften. Mit Erfahrung und fachlicher Kompetenz tragen Franz Kirbisser und Michael Poschauko seit 25 Jahren, Josef Schreiber seit 20 und Markus Puches nun schon seit 10 Jahren einen wesentlichen Teil zum Erfolg von GERA Montagen bei. Das freut uns enorm und macht uns auch sehr stolz, denn nach so langer Zeit als Arbeitgeber verbindet uns hier auch vieles, was über die Arbeit hinaus geht.<br>Für ihr Engagement und ihre Treue haben wir den vier Langzeit-Mitarbeitern Reisegutscheine sowie eine Ehren-Urkunde überreicht. Leider erlaubt es uns die momentane Situation rund um COVID 19 nicht zusammen in passendem Rahmen feiern. Umso mehr möchten wir dafür an dieser Stelle unseren herzlichsten Dank aussprechen und den vier Kollegen noch viele weitere Jahre in unserem Haus, Erfolge, Glück und Gesundheit wünschen!",
			"story6ArticleText": "",
			"story7Date": "17. November 2021",
			"story7Title": "Herzlich willkommen bei GERA!",
			"story7TitleText": "Über Besuch durften wir uns diesen Herbst freuen! Der polytechnische Lehrgang aus Mureck schaute bei uns vorbei und wir plauderten über unser Unternehmen und die Aufgaben unserer Monteure bei den weltweiten Einsätzen. 25 Schüler und drei Begleitpersonen bekamen eine „GERA Inside“-Tour und lernten unseren Betrieb näher kennen. Wir redeten unter anderem über unsere Tätigkeitsbereiche, unsere Geschichte und was es braucht, um ein echter „GERA-Profi“ zu werden.      Wir freuen uns schon auf den nächsten Besuch und wer weiß: Vielleicht sieht man sich in ein paar Jahren als Kollegen ja wieder.",
			"story7ArticleText": "",
			"story8Date": "10. Februar 2022",
			"story8Title": "Vielen Dank, dass ihr bei uns seid!",
			"story8TitleText": "In diesem Jahr feiert GERA bereits seinen 30. Geburtstag, was ohne die tolle und treue Arbeit unserer Mitarbeiter niemals möglich gewesen wäre!<br>Umso mehr freut es uns einige der fleißigen GERA-Mitarbeiter für eben diese Treue und den Einsatz für das Unternehmen auszuzeichnen. In diesem Sinne bleibt uns nur DANKE zu sagen an<br><br>Gerhard Legenstein für 20 Jahre<br>Herbert Binder für 25 Jahre<br>Horst Blühwald für 25 Jahre<br>Tomaz Rojc für 10 Jahre<br>Manfred Wischenbart für 20 Jahre<br>Michael Lechner für 20 Jahre<br>Martin Sudi für 10 Jahre<br><br>und wir hoffen, gemeinsam mit euch noch viele Jahre und Projekte zu erleben. Schön, dass ihr Teil der GERA-Familie seid. Alles Gute!",
			"story8ArticleText": "",
      "story9Date": "3. März 2022",
			"story9Title": "30 Jahre GERA – da tut sich einiges!",
			"story9TitleText": "Unglaublich, wie schnell die Zeit vergeht, aber wir feiern bereits unseren 30. Geburtstag! Daher starten wir mit vielen Specials in dieses besondere Jahr, soviel sei bereits verraten. Eines davon ist „GERA on tour“. Es ist uns ein großes Anliegen, dass sich unsere fleißigen Mitarbeiter trotz der teilweise großen Distanz zu uns als Teil der GERA-Familie fühlen. Darum haben wir uns gedacht: Da die Baustelle und unsere Mitarbeiter schwer zu uns kommen können, kommen wir eben zu ihnen! Unsere Prokuristen Herbert Raggam und Rudi Grabner besuchen im Zuge von „GERA on tour“ aber nicht nur die Baustellen, sondern planen auch einen entspanntes „After-Work-Programm“ – einfach, um mal danke zu sagen. Wie so ein Tag aussehen kann, erfährt ihr hier!<h3 class=\"fw800 m30\">Vienna calling – GERA besucht die Hauptstadt</h3>Als erste Station von „GERA on tour“ wurde die Hauptstadt auserkoren, genauer gesagt das österreichische Parlament. Dort montieren vier fleißige Mitarbeiter aktuell Türelemente, Garderoben und verschieden Pulte, was uns besonders stolz macht, dass der Sitz unserer Regierung auf unser Können vertraut. Nach der Besichtigung der Baustelle in einem der interessantesten Gebäude des Landes ging es genau so informativ weiter. Gemeinsam mit unseren vier Mitarbeitern führte uns ein Stadt-Guide unter anderem zur Hofburg, dem Palais Eschenbach und noch weiteren Sehenswürdigkeiten. Zum Ausklang eines produktiven Arbeitstages gab es noch ein gutes chinesisches Essen, bei dem zum verdienten Feierabend-Bier angestoßen wurde. Vielen Dank an unsere Mitarbeiter, die alles dafür tun, dass diese Baustelle ein Erfolg wird und GERA auch in den nächsten 30 Jahren so wachsen wird!",
			"story9ArticleText": "",
      "story10Date": "5. Mai 2022",
			"story10Title": "GERA ON TOUR – in Graz",
			"story10TitleText": "\"GERA on tour\" war wieder unterwegs auf einer unserer vielen Baustellen. Diesmal führte der Weg nach Graz auf den Jakominiplatz, wo in Kürze das neue „Hotel Motel One“ fertiggestellt wird. Unsere Monteure montierten dort in der Zeit von Ende März bis Anfang Mai 160 Zimmer und haben damit einen großen Beitrag zur Schönheit dieses Hotels geleistet. Nach Besichtigung dieser sehr beeindruckenden Baustelle haben wir den Abend bei einem gemeinsamen Abendessen mit unseren Monteuren ausklingen lassen. Das habt ihr euch redlich verdient!",
			"story10ArticleText": "",
      "story11Date": "18. Mai 2022",
			"story11Title": "Hallo, Eisenstadt!",
			"story11TitleText": "Am 17. und 18.5.2022 war „GERA on Tour“ wieder auf Achse. Diesmal haben wir unsere Baustelle, das Hotel Pauls in Eisenstadt, besucht.  Den Start bildete eine Besichtigung des Schloss Esterházy, dass in unmittelbarer Nähe zur Baustelle liegt.<br>Dort konnte man unter anderem den Keller, die Prunkzimmer aber auch eine Ausstellung von Joseph Haydn bestaunen und sich ein Bild vom Wirken der Esterházy´s machen. Nach der Kultur durfte auch die Kulinarik nicht fehlen und so setzten wir uns anschließend gemütlich im „Haydnbräu“ zusammen um uns zu stärken und uns auszutauschen. <br>Der zweite Tag war dann unserem Projekt, dem Hotel Pauls gewidmet und wir haben uns den Montagefortschritt der insgesamt 118 Zimmern angesehen und uns ein Bild über die Arbeiten gemacht, die noch bis Ende Juni andauern. Dann wird Eisenstadt um eine Nächtigungsmöglichkeit reicher sein und - eine Reise ist das Burgenland ohnehin immer wert.",
			"story110ArticleText": "",
      "story12Date": "22. Juli 2022",
			"story12Title": "Wir sagen DANKE für 20 Jahre Firmentreue!",
			"story12TitleText": "Nachdem unsere Mitarbeiter stets rund um den Globus verteilt ihr Handwerk unter Beweis stellen, bedarf es oft ein bisschen Zeit und Geduld bis ein passender Termin für ein persönliches Treffen gefunden ist. Doch es wäre gelacht, wenn wir nicht auch diese Herausforderung meistern würden. Und siehe da, nach einem halben Jahr sind wir stolz, unserem Kollegen Manfred Wischenbart nun offiziell die Urkunde zur 20-jährigen Firmentreue übergeben zu dürfen. Wir danken dir für deinen Einsatz, deine Motivation, dein Können und deine Treue zu GERA. Viel Freude mit den Gutscheinen und auf zahlreiche weitere Jahre Teamwork!",
			"story120ArticleText": "",
      "story13Date": "2. August 2022",
			"story13Title": "30 Jahre - 30 Challenges - 30 Gewinner",
			"story13TitleText": "Das Jahr 2022 ist ein ganz spezielles Jahr für GERA. So dürfen wir heuer stolz auf 30 Jahre Firmengeschichte zurückblicken. Das ist Anlass genug, uns etwas Besonderes für unsere Mitarbeiter einfallen zu lassen. Mit einem über 30 Wochen laufenden Gewinnspiel und 30 sensationellen Preisen möchten wir uns für eure Arbeit, euren Einsatz, eure Verlässlichkeit und Treue bedanken. Um jedem einzelnen die Teilnahme und den Spaß ermöglichen zu können, läuft unser Gewinnspiel, bestehend aus 30 Fragen, via SMS ab. Wer diese innerhalb einer Woche richtig beantwortet, sammelt Punkte. Die fünf Mitarbeiter mit den meisten Punkten dürfen dann im „Grande Finale“ bei unserer diesjährigen Weihnachtsfeier gegeneinander antreten und sich um die drei großen Hauptpreise „challengen“. Wir wünschen allen unseren Mitarbeitern viel Spaß und viel Glück beim Mitspielen und freuen uns schon jetzt auf das Finale.",
			"story130ArticleText": "",
      "story14Date": "22. Dezember 2022",
			"story14Title": "Weihnachtsfeier, anlässlich des 30. Jährigen Bestehens",
			"story14TitleText": "Am 22.12.2022 fand im Schloss Seggau nähe Leibnitz die Weihnachtsfeier statt.<br><br>Aufgrund des 30. jährigen Bestehens sind wir nach 10 Jahren zu dieser sehr festlichen und feierlichen Lokation zurück gekehrt.<br>Es waren alle Mitarbeiter samt Begleitung geladen und auch die Möglichkeit der Nächtigung inkl. Frühstück im Schloss wurde angeboten.<br>Zusätzlich zu den Mitarbeitern wurden auch noch vom Team Holz im Bau Christian Hofer u. Sabine, sowie unsere langjährige Buchhalterin Ingrid Schrötter mit Mann und auch unser Steuerberater Dr. Hans Winter eingeladen, welche auch anwesend waren.<br><br>Der Ablauf war wie folgt:<br>Zusammentreffen im Schloss Innenhof bei Punch und Glühwein mit Feuerschale, festlich untermalt mit Bläsern die im beim Eintreffen der Gäste im Hintergrund für eine festliche Stimmung sorgten.<br>Nach dem Eintreffen aller Gäste gingen wir dann gemeinsam in den festlich geschmückten Saal, wo ich durch das Programm führte und das mit der Begrüßung durch den Gründer und GF Helmut Raggam startete, anschließend blickte Rudolf Grabner<br>In einer kleine PPT-Präsentation auf 30 Jahre Gera Montagen und die eigenen Anfänge zurück. Danach wurde gegessen. Die Vorspeise und Suppe wurde serviert, die Haupt- und Nachspeisen wurden mittels schmackhaften und umfangreichen Buffet angeboten.<br>Nach dem Essen kam es zum Großen Finale des Gera Mitarbeiter Gewinnspiels unter dem Motto „30 Jahre, 30 Preise“. Die 3 bestplatzierten der Vorrunde (20 Quizfragen) kämpften nach dem Essen in drei unterschiedlichen Bewerben um die Hauptpreise die da waren 1. Preis ein E-Scooter, 2. Preis Griller, 3. Preis Tablet!<br><br>Die 3 Bewerbe waren:<br><ul><li>Schätzen des Gewichts eines Paketes</li><li>Nageln in einen Holzstock</li><li>Darts – wo jedoch beim Abschuss des Dartpfeils zeitgleich ein Tischtennisball zumindest 3x auf dem Schläger „gepepelt“ werden musste</li></ul>Für die Disziplinen gab es Punkte und der Finalist mit den meisten Punkten, gewann dann den Hauptpreis, den zweiten und den dritten Hauptpreis.<br><br>Im Finale traten August Spätauf, Franz Kirbisser und Wolfgang Rathkolb gegeneinander an. Rathkolb vertrat den leider erkrankten Michael Poschauko der leider an der Feier nicht teilnehmen konnte.<br>Geleitet wurde das Finale durch mich, die Überprüfung und den ordentlichen Ablauf kontrollierte Hr. Dr. Hans Winter, damit ja alles sein Ordnung hatte!<br>Zu guter Letzt siegte August Spätauf der sich über eine E-Scooter im Wert von knapp € 1000,- freuen konnte, vor Wolfgang Rathkolb, der für Michael Poschauko den Griller erkämpft hatte und Franz Kirbisser, der sich über ein nagelneues Tablet freuen durfte!<br><br>Die restlichen 27 Preise gingen an jene TN welche die nächstmeisten Punkte hatten.<br><br>Zum Schluss wurden auch noch einige lang dienende Mitarbeiter für ihre Firmentreue ausgezeichnet, allen voran Rudolf Grabner, der der erste Gera Mitarbeiter war und nun schon seit über 30 Jahren im Unternehmen ist.<br>15. Jahre halten bereits Franz Gerster, Christian Wutte und Markus Kothgasser unserem Unternehmen die Treue, herzlichen Dank dafür!<br><br>Nach dem offiziellen Teil wurde in gemütlicher Runde noch bis in den Morgen gefeiert und es war ein sehr schönes Fest in einer stimmungsvollen Umgebung.<br><br>Auf in die nächsten 30 Jahre…",
			"story140ArticleText": "",
      "story22Date": "29. Februar 2024",
			"story22Title": "Mitarbeiterehrung",
			"story22TitleText": "Besonders stolz sind wir bei Gera Montagen darauf, dass unsere Mitarbeiter gerne für uns arbeiten! 🤩Im Jahr 2023 durften wir insgesamt 7 Mitarbeiter auszeichnen, die unserem Unternehmen bereits seit 10,15, 20 oder gar 25 Jahren treu sind.🎖️<br>Wir freuen uns darauf, weitere Jubiläen zu feiern! 🤝",
			"story220ArticleText": "",
      "story23Date": "14. Jänner 2026",
			"story23Title": "Danke für viele gemeinsame Jahre",
      "story23TitleText": "Manche Wege beginnen als Job und werden zu einer gemeinsamen Geschichte.🤩<br>Fünf unserer Mitarbeiter stehen für 10 bis 30 Jahre Vertrauen, Zusammenhalt und Engagement, die unser Unternehmen geprägt haben! 🎖️<br><br>Wir sagen von Herzen Danke an: 🤝<br><ul><li><b>Aljaz Svensek</b> (leider ohne Bild) – 10 Jahre</li><li><b>Markus Puches</b> – 15 Jahre</li><li><b>Josef Schreiber</b> – 25 Jahre</li><li><b>Franz Kirbisser</b> – 30 Jahre</li><li>Michael Poschauko - 30 Jahre</li></ul> für ihre Loyalität, ihre Leidenschaft und ihren täglichen Einsatz. Jede einzelne dieser langjährigen Verbindungen ist ein Zeichen dafür, dass Menschen bei uns mehr als nur arbeiten – sie wachsen mit dem Unternehmen und machen es zu dem, was es heute ist. <br>Wir sind stolz auf das gemeinsam Erreichte und freuen uns auf viele weitere Jahre des Miteinanders.",
      "story23ArticleText": "",
      "story24Date": "17. Februar 2026",
			"story24Title": "Gera Montagen zu Besuch im Polytechnikum Mureck",
      "story24TitleText": "Gera Montagen war kürzlich zu Gast im Polytechnikum Mureck und stellte das Unternehmen zwei Klassen im Rahmen eines praxisnahen Vortrags vor. Ziel der Veranstaltung war es, den Schüler/innen spannende Einblicke in die Arbeitswelt sowie in die vielfältigen Einsatzbereiche des Unternehmens zu geben.<br>Von Beginn an wurden die Jugendlichen aktiv in die Präsentation eingebunden. Durch Fragen, kurze Aufgabenstellungen und anschauliche Beispiele erhielten sie einen lebendigen Eindruck vom Wirken von Gera Montagen und den unterschiedlichen Tätigkeitsfeldern – von Montagearbeiten bis hin zu abwechslungsreichen Projekten im In- und Ausland.<br>Den Abschluss bildete ein kleiner Wettbewerb, bei dem drei Schüler/innen gegeneinander antraten und ihr Geschick unter Beweis stellten. Mit viel Engagement und Begeisterung meisterten sie die Aufgaben – als Anerkennung gab es kleine Preise für die Teilnehmer/innen.<br>Die Veranstaltung zeigte einmal mehr, wie wichtig der direkte Austausch zwischen Schule und Wirtschaft ist. Gera Montagen freut sich, junge Menschen für den Beruf des Montagetischlers zu begeistern und sie auf ihrem weiteren Bildungs- und Berufsweg zu unterstützen.<br>",
      "story24ArticleText": ""
		},
		"en": {
			"title": "GERA Inside",
			"titleText": "An especially high degree of quality is necessary in everything we do! Our reference list is long and is as diversified as our trade is. You can find a list of some of our most outstanding projects worldwide after over 20 years in the business and many hundred projects around the globe.",
			"more": "More...",
			"on": "on",
			"story1Date": "April, 20th 2020",
			"story1Title": "Teambuilding on the water",
			"story1TitleText": "About once per year we go to unusual places or to a relaxed environment outside of work so that our management team (management and project managers) can strategically orient itself to our goals for the future. We have special memories of the boat trip in 2017.",
			"story1ArticleText": "",
			"story2Date": "June, 14.th 2020",
			"story2Title": "Landlady Paris would be proud of us",
			"story2TitleText": "The Hotel Hilton at the Viennese City Park is a top location. We recently finished a one-year construction phase with more than 600 rooms and suites. In spite of the difficult conditions this year we did what was almost impossible and finished the project on time!<br>It is time to just say THANKS to our first-class team!",
			"story2ArticleText": "",
			"story3Date": "July, 9.th 2020",
			"story3Title": "Parliament building in Vienna",
			"story3TitleText": "While our National Council is leisurely preparing for its summer break in Parliament, we are doing the opposite! We are working hard to enshroud these time-honoured rooms in a new shine.",
			"story3ArticleText": "",
			"story4Date": "July, 14.th 2020",
			"story4Title": "Get active again",
			"story4TitleText": "Getting active with GERA is almost legendary…. Spending time together doing thrilling, exciting, funny things, doing sports and having fun such as go-carting. We have enjoyed doing this together a lot, and soon it will be time again for new highlights to take place in our internal event series.",
			"story4ArticleText": "",
			"story5Date": "July, 29.th 2020",
			"story5Title": "North German vision meets South Styrian willpower",
			"story5TitleText": "In picturesque Damp on the Baltic Sea we were especially impressive in the first few months of this year: we perfectly installed more than 400 rooms and suites in an extremely short installation time period of only 4 months. Our customer is so happy about our top performance that it compiled a photo album for us as documentation of our iron willpower and follow-through.<br>A big thank you to our great team for doing a terrific job!",
			"story5ArticleText": "",
			"story6Date": "March, 9.th 2021",
			"story6Title": "A company's most valuable asset is its employees",
			"story6TitleText": "Das wissen auch wir, und umso mehr erfüllt es uns mit Freude und Stolz, dass wir unlängst vier langjährig treuen Teammitgliedern Danke sagen zu durften. Mit Erfahrung und fachlicher Kompetenz tragen Franz Kirbisser und Michael Poschauko seit 25 Jahren, Josef Schreiber seit 20 und Markus Puches nun schon seit 10 Jahren einen wesentlichen Teil zum Erfolg von GERA Montagen bei. Das freut uns enorm und macht uns auch sehr stolz, denn nach so langer Zeit als Arbeitgeber verbindet uns hier auch vieles, was über die Arbeit hinaus geht.<br>Für ihr Engagement und ihre Treue haben wir den vier Langzeit-Mitarbeitern Reisegutscheine sowie eine Ehren-Urkunde überreicht. Leider erlaubt es uns die momentane Situation rund um COVID 19 nicht zusammen in passendem Rahmen feiern. Umso mehr möchten wir dafür an dieser Stelle unseren herzlichsten Dank aussprechen und den vier Kollegen noch viele weitere Jahre in unserem Haus, Erfolge, Glück und Gesundheit wünschen!",
			"story6ArticleText": "",
      "story7Date": "17. November 2021",
      "story7Title": "Herzlich willkommen bei GERA!",
      "story7TitleText": "Über Besuch durften wir uns diesen Herbst freuen! Der polytechnische Lehrgang aus Mureck schaute bei uns vorbei und wir plauderten über unser Unternehmen und die Aufgaben unserer Monteure bei den weltweiten Einsätzen. 25 Schüler und drei Begleitpersonen bekamen eine „GERA Inside“-Tour und lernten unseren Betrieb näher kennen. Wir redeten unter anderem über unsere Tätigkeitsbereiche, unsere Geschichte und was es braucht, um ein echter „GERA-Profi“ zu werden.      Wir freuen uns schon auf den nächsten Besuch und wer weiß: Vielleicht sieht man sich in ein paar Jahren als Kollegen ja wieder.",
      "story7ArticleText": "",
      "story23Date": "14. January 2026",
			"story23Title": "Thank you for many years of shared success",
      "story23TitleText": "Some paths begin as a job and become a shared story.🤩<br>Five of our employees represent 10 to 30 years of trust, cohesion, and commitment that have shaped our company! 🎖️<br><br>We say a heartfelt thank you to: 🤝<br><ul><li><b>Aljaz Svensek</b> (unfortunately without a picture) – 10 years</li><li><b>Markus Puches</b> – 15 years</li><li><b>Josef Schreiber</b> – 25 years</li><li><b>Franz Kirbisser</b> – 30 years</li></ul>for their loyalty, their passion, and their daily dedication. Every single one of these long-standing connections is a sign that people here do more than just work – they grow with the company and make it what it is today. <br>We are proud of what we have achieved together and look forward to many more years of cooperation.",
      "story23ArticleText": "",
      "story24Date": "17. Februar 2026",
      "story24Title": "Gera Montagen at Polytechnikum Mureck",
      "story24TitleText": "Gera Montagen recently visited the Polytechnikum Mureck to present the company to two classes through a hands-on, practical lecture. The goal of the event was to provide students with exciting insights into the professional world and the diverse areas of application within the company.<br>From the very beginning, the students were actively involved in the presentation. Through interactive questions, short tasks, and vivid examples, they gained a firsthand impression of Gera Montagen’s work and its various fields of activity—ranging from assembly work to diverse projects both at home and abroad.<br>The event concluded with a small competition where three students competed against one another to put their skills to the test. They tackled the tasks with great commitment and enthusiasm, and as a reward, the participants received small prizes for their efforts.<br>This event once again highlighted the importance of direct exchange between schools and the business community. Gera Montagen is delighted to inspire young people to pursue careers as assembly joiners and to support them on their future educational and professional paths.<br>",
      "story24ArticleText": ""
		}
	}
</i18n>
